var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup25185(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49.35,
    height: 44.4,
    viewBox: "0 0 49.35 44.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.102,
    y1: 1.005,
    x2: 0.361,
    y2: 0.612,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#c6a553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97792b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.919,
    y1: 0.924,
    x2: 0.592,
    y2: 0.589,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.202,
    y1: 0.242,
    x2: 0.722,
    y2: 0.692,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#103d32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    stopColor: "#0d241e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#103b30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777,
    stopColor: "#0c201a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#103d32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.931,
    y1: 0.2,
    x2: 0.183,
    y2: 0.72,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97792b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#c6a553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#f9ea97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#dabc6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#f3d680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#896d23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a98d46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -0.022,
    y1: 0.528,
    x2: 1.019,
    y2: 0.432,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6a553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#f9ea97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#dabc6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812,
    stopColor: "#f2df8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3d680"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -3.933,
    y1: 42.828,
    x2: -2.905,
    y2: 42.828,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -4.042,
    y1: 43.499,
    x2: -3.013,
    y2: 43.499,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.753,
    y1: -0.079,
    x2: 0.205,
    y2: 1.131,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#896d23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#dabc6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9ea97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.385,
    y1: -0.166,
    x2: 0.555,
    y2: 1.148,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#f8fffb",
    stopOpacity: 0.867
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    stopColor: "#eafff5",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#defff0",
    stopOpacity: 0.392
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#d5ffec",
    stopOpacity: 0.224
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#cfffe9",
    stopOpacity: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911,
    stopColor: "#cbffe7",
    stopOpacity: 0.027
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#caffe7",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25185",
    "data-name": "Group 25185",
    transform: "translate(-519.946 -56.088)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26528",
    "data-name": "Path 26528",
    d: "M563.678,57.371l-19.224,11.1v22.2l19.224,11.1,19.224-11.1V68.47Zm17.63,32.377-17.63,10.178-17.63-10.178V69.391l17.63-10.178,17.63,10.178Z",
    transform: "translate(-19.06 -1.283)",
    fill: "#0f3229"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(519.946 85.963)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M519.946,170.279a11.629,11.629,0,0,0,6.017,2.352,7.357,7.357,0,0,1-2.27,4.472,45.145,45.145,0,0,0,12.652-4.579l-3.348-6.9a44.827,44.827,0,0,1-13.051,4.655Z",
    transform: "translate(-519.946 -165.626)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M543.818,184.666l8.468.524-3.222-3.038Z",
    transform: "translate(-537.496 -177.774)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(552.897 85.963)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M660.761,170.279a11.63,11.63,0,0,1-6.017,2.352,7.359,7.359,0,0,0,2.27,4.472,45.146,45.146,0,0,1-12.652-4.579l3.348-6.9A44.824,44.824,0,0,0,660.761,170.279Z",
    transform: "translate(-644.362 -165.626)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M658.9,184.666l-8.468.524,3.222-3.038Z",
    transform: "translate(-648.826 -177.774)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M562.625,57.373l-18.181,10.5V88.864l18.181,10.5,18.181-10.5V67.87Z",
    transform: "translate(-18.01 -0.08)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M562.635,57.371l-18.181,10.5V88.862l18.181,10.5,18.181-10.5V67.868Zm16.673,30.62-16.673,9.626-16.673-9.626V68.739l16.673-9.626,16.673,9.626Z",
    transform: "translate(-18.017 -0.078)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(525.379 84.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M578.037,167.115a161.439,161.439,0,0,0-36.692,0l-.886-7.742a169.233,169.233,0,0,1,38.463,0Z",
    transform: "translate(-540.46 -158.277)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M541.083,164.883l.055.478a169.243,169.243,0,0,1,38.023,0q.027-.239.055-.478A169.747,169.747,0,0,0,541.083,164.883Z",
    transform: "translate(-540.918 -162.344)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M543.087,182.47a163.952,163.952,0,0,1,36.991,0q.027-.239.055-.478a164.391,164.391,0,0,0-37.1,0Z",
    transform: "translate(-542.351 -174.939)",
    fill: "url(#linear-gradient-9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M608.211,190.211l.559,1.133,1.251.182-.905.882.214,1.246-1.119-.588-1.119.588.214-1.246-.905-.882,1.251-.182Z",
    transform: "translate(-63.558 -97.737)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M559.486,92.347v-9.6a1.447,1.447,0,0,1,1.058-1.394l12.734-6.713a1.451,1.451,0,0,1,.777,0l12.734,6.713a1.447,1.447,0,0,1,1.058,1.394v9.6L574.163,85.9Z",
    transform: "translate(-29.068 -12.732)",
    opacity: 0.8,
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25185-2",
    "data-name": "Group 25185",
    transform: "translate(536.344 66.555)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_17",
    "data-name": "Path 17",
    transform: "translate(-348.892 -251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47873",
    "data-name": "Path 47873",
    d: "M361.092,265.852h0a.571.571,0,0,1-.264-.066l-4.245-2.232a.068.068,0,0,0-.031-.008.073.073,0,0,0-.029.007l-4.247,2.233a.563.563,0,0,1-.7-.137.559.559,0,0,1-.123-.459l.811-4.728a.07.07,0,0,0-.019-.058l-3.435-3.348a.565.565,0,0,1,.313-.964l4.747-.69a.066.066,0,0,0,.05-.036l2.122-4.3a.565.565,0,0,1,1.014,0l2.123,4.3a.065.065,0,0,0,.049.036l4.747.69a.565.565,0,0,1,.313.964l-3.434,3.349a.063.063,0,0,0-.019.058l.811,4.727a.567.567,0,0,1-.557.662Z",
    fill: "#feda09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47874",
    "data-name": "Path 47874",
    d: "M356.552,251a.311.311,0,0,0-.283.176l-2.122,4.3a.319.319,0,0,1-.238.173l-4.747.689a.315.315,0,0,0-.174.538l3.434,3.348a.313.313,0,0,1,.091.279l-.811,4.728a.316.316,0,0,0,.458.333l4.246-2.232a.31.31,0,0,1,.293,0l4.246,2.232a.315.315,0,0,0,.457-.333l-.811-4.728a.318.318,0,0,1,.091-.279l3.435-3.348a.316.316,0,0,0-.175-.538l-4.747-.689a.317.317,0,0,1-.237-.173l-2.123-4.3a.31.31,0,0,0-.283-.176m0-.5a.811.811,0,0,1,.732.455l2.079,4.214,4.651.675a.815.815,0,0,1,.451,1.391l-3.365,3.281.795,4.632a.814.814,0,0,1-1.183.859l-4.16-2.187-4.16,2.187a.815.815,0,0,1-1.183-.859l.795-4.632-3.366-3.281a.816.816,0,0,1,.452-1.391l4.651-.675,2.08-4.215A.812.812,0,0,1,356.552,250.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M356.723,268.9a6.609,6.609,0,0,0,9.042-5.193l2.628.382a.252.252,0,0,1,.14.43l-3.551,3.461a.253.253,0,0,0-.073.223l.838,4.887a.252.252,0,0,1-.366.266l-4.388-2.307a.253.253,0,0,0-.235,0l-4.389,2.307a.252.252,0,0,1-.366-.266Z",
    transform: "translate(-353.215 -258.726)",
    fill: "#f4b608",
    opacity: 0.19
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup25185);
export default __webpack_public_path__ + "static/media/Group_25185.8395aaf666cd61fa836884decb6ea2f0.svg";
export { ForwardRef as ReactComponent };